
import {
  defineComponent,
  computed,
  watch,
  SetupContext,
  toRefs,
  ref
} from "vue";
import NativeClient from "@/client/native-client";
  
export default defineComponent({
  name: "MypageSelectTabs",
  props: {
    /** 左側の文言 */
    leftTitle: {
      type: String,
      required: true
    },
    /** 左側の文言 */
    rightTitle: {
      type: String,
      required: true
    },
    /** 初期選択 */
    initialSelect: {
      type: Number,
      default: 0
    }
  },
  setup(props, context: SetupContext) {
    const { initialSelect } = toRefs(props);
    const selectedTab = ref(initialSelect.value);

    watch(initialSelect, () => {
      NativeClient.sendDebugLog("MypageSelectTabs watch");
      if (initialSelect.value != selectedTab.value) {
        NativeClient.sendDebugLog("MypageSelectTabs watch tan change");
        selectedTab.value = initialSelect.value;
      }
    });

    // テキスト装飾
    const styleOpacitySelectedLeft = computed(() => {
      NativeClient.sendDebugLog("MypageSelectTabs styleTextColorSelectedReport()");
      if (selectedTab.value == 0) {
        return { opacity: 1.0 };
      }
      return { opacity: 0.0 };
    });
    const styleTextColorSelectedLeft = computed(() => {
      NativeClient.sendDebugLog("MypageSelectTabs styleTextColorSelectedLeft");
      if (selectedTab.value == 0) {
        return { color: `#000000` };
      }
      return  { color: `#707070`};
    });
    const styleOpacitySelectedRight = computed(() => {
      NativeClient.sendDebugLog("MypageSelectTabs styleOpacitySelectedRight");
      if (selectedTab.value == 1) {
        return { opacity: 1.0 };
      }
      return { opacity: 0.0 };
    });
    const styleTextColorSelectedRight = computed(() => {
      NativeClient.sendDebugLog("MypageSelectTabs styleTextColorSelectedMylist");
      if (selectedTab.value == 1) {
        return { color: `#000000` };
      }
      return { color: `#707070` };
    });
    // 選択ボタンのハンドラ
    const selectLeft = () => {
      // 履歴選択
      if (selectedTab.value != 0) {
        NativeClient.sendDebugLog("MypageSelectTabs selectLeft");
        selectedTab.value = 0;
        context.emit("select-tabs", 0);
      }
    };
    const selectRight = () => {
      // お気に入り選択
      if (selectedTab.value != 1) {
        NativeClient.sendDebugLog("MypageSelectTabs selectRight");
        selectedTab.value = 1;
        context.emit("select-tabs", 1);
      }
    };

    return {
      styleOpacitySelectedLeft,
      styleTextColorSelectedLeft,
      styleOpacitySelectedRight,
      styleTextColorSelectedRight,
      selectLeft,
      selectRight
    };
  }
});
